<template>
    <div class="relative flex flex-col w-full max-w-screen-lg p-4 mx-auto text-white bg-pink-600 shadow-lg md:flex-row rounded-2xl">
        <p class="w-full font-semibold text-center">Open Source Management | P.IVA 03818030409 | <a href="/privacy-policy" class="hover:underline">Privacy Policy</a> | <a href="/cookie-policy" class="hover:underline">Cookie Policy</a></p>
        <scroll-link href="#app" title="torna a inizio pagina" class="absolute w-10 h-10 p-3 text-white bg-transparent rounded-full shadow-lg right-2 bottom-2 hover:bg-purple-500"><img src="/assets/icons/arrow-up.svg" alt="freccia verso l'alto"></scroll-link>
    </div>
</template>

<script>
export default {
  name: 'colophon',
  components: {
      ScrollLink: () => import('../Components/ScrollLink.vue')
  },
}
</script>
